import { RoutesObj } from "@/@types";
import adminsRoutes from "./admins.routes";
import chargersRoutes from "./chargers.routes";
import connectorsRoutes from "./connectors.routes";
import homeRoutes from "./home.routes";
import locationsRoutes from "./locations.routes";
import partnershipRoutes from "./partnership.routes";
import plansRoutes from "./plans.routes";
import sessionsRoutes from "./sessions.routes";
import usersRoutes from "./users.routes";

export const routes: RoutesObj = {
  login: {
    path: "/login",
    name: "Login",
    component: () => import("@/presentation/views/Login/Login.vue"),
  },
  password_recovery: {
    path: "/esqueci-a-senha",
    name: "PasswordRecovery",
    component: () =>
      import("@/presentation/views/PasswordRecovery/PasswordRecovery.vue"),
  },
  password_reset: {
    path: "/redefinir-senha",
    name: "PasswordReset",
    meta: { requiresAuth: true },
    component: () =>
      import("@/presentation/views/PasswordReset/PasswordReset.vue"),
  },
  
  home: homeRoutes,
  sessions: sessionsRoutes,
  users: usersRoutes,
  locations: locationsRoutes,
  chargers: chargersRoutes,
  connectors: connectorsRoutes,
  plans: plansRoutes,
  admins: adminsRoutes,
  partnerships: partnershipRoutes,

  not_found: {
    path: "/404",
    name: "NotFound",
    component: () => import("@/presentation/views/NotFound/NotFound.vue"),
  },
};
